import React, { useCallback } from "react";
import { GetUser } from "../../api/userapi";
import Infinite from "../../components/Infinite/Infinite";
import LeaderCard from "../../components/LeaderCard/LeaderCard";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
import UseUserData from "../../hooks/UseUserData";
import { formatDate } from "../../lib/lib";
import "./css/index.css";

const csvHeader = [
  "아이디",
  "닉네임",
  "이메일",
  "가입일",
  "마케팅 동의",
  "유저",
];

function Leader() {
  const [
    data,
    SearchUser,
    LeaderInsert,
    LeaderDelete,
    RemoveUsers,
    PagingUpdate,
  ] = UseUserData({ limit: 30 });
  const CsvUserData = useCallback((): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const GetUserData = (idx: number, list: any[]) => {
        GetUser(undefined, idx + 1, 100000).then(({ data }) => {
          if (data) {
            const {
              pg: { page_cur, page_last },
            } = data;
            if (page_cur === page_last) {
              resolve(
                list.map(
                  ({
                    login_id,
                    login_nm,
                    usr_email,
                    def_reg_at,
                    agr_adv,
                    usr_typ,
                  }) => {
                    return [
                      login_id,
                      login_nm ? login_nm : "-",
                      usr_email,
                      formatDate(def_reg_at, "-"),
                      agr_adv ? "동의" : "미동의",
                      usr_typ === "TMPL" ? "팀플러" : "팀리더",
                    ];
                  }
                )
              );
              return list;
            } else {
              GetUserData(idx + 1, [...list, ...data.lst]);
            }
          }
        });
      };
      GetUser(undefined, 1, 100000).then(({ data }) => {
        if (data) {
          const {
            pg: { page_cur, page_last },
          } = data;
          if (page_last > 1) {
            GetUserData(page_cur, data.lst);
          } else {
            resolve(
              data.lst.map(
                ({
                  login_id,
                  login_nm,
                  usr_email,
                  def_reg_at,
                  agr_adv,
                  usr_typ,
                }) => {
                  return [
                    login_id,
                    login_nm ? login_nm : "-",
                    usr_email,
                    formatDate(def_reg_at, "-"),
                    agr_adv ? "동의" : "미동의",
                    usr_typ === "TMPL" ? "팀플러" : "팀리더",
                  ];
                }
              )
            );
          }
        }
      });
    });
  }, []);
  const SearchLeader = useCallback(
    (filter: string[], text: string) => {
      SearchUser(
        filter.includes("leader")
          ? { isLeader: true, text }
          : {
              isLeader: false,
              text,
            }
      );
    },
    [SearchUser]
  );

  return (
    <main className="user-leader-page">
      <div className="wrapper">
        <ListSearchSection
          title="팀플리더 설정"
          placeholder="회원 검색"
          filter={SerachFilter}
          isExel={true}
          Search={SearchLeader}
          csvTitle="팀플리더 목록"
          headers={csvHeader}
          csvData={CsvUserData}
        />
        <div className="tag-wrapper">
          {tagArr.map(({ title, type }, idx) => {
            return (
              <div key={idx} className={`tag ${type}`}>
                {title}
              </div>
            );
          })}
        </div>
        <div className="list-wrapper">
          {data?.map((item, idx) => {
            return (
              <LeaderCard
                key={idx}
                data={item}
                LeaderInsert={LeaderInsert}
                LeaderDelete={LeaderDelete}
              />
            );
          })}
          <Infinite PagingUpdate={PagingUpdate} />
        </div>
      </div>
    </main>
  );
}

export default Leader;

const SerachFilter = [
  {
    type: "leader",
    title: "팀플리더만 보기",
  },
];

const tagArr = [
  {
    title: "번호",
    type: "number",
  },
  {
    title: "아이디",
    type: "id",
  },
  {
    title: "이메일",
    type: "email",
  },
  {
    title: "활동명",
    type: "nickname",
  },
  {
    title: "프로젝트오픈수",
    type: "project",
  },
  {
    title: "상세보기",
    type: "detail",
  },
  {
    title: "팀플리더 등록",
    type: "insert",
  },
];
